module.exports = __webpack_public_path__ + "static/img/003.3a44ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/003.png
// module id = r3/2
// module chunks = 1